import { cn } from '@/utils/utils';
import { PopoverContentProps } from '@radix-ui/react-popover';
import { CheckIcon, ChevronDown, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './Button';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from './Command';
import { Popover, PopoverContent, PopoverTrigger } from './Popover';
import slugify from 'slugify';

interface ItemCombobox {
    label: string,
    value: string,
    code?: string | number
}

interface ComboboxProps {
    value: string,
    onChange: (item: any) => void,
    items: ItemCombobox[],
    placeholder?: string,
    floatingLabel?: boolean,
    label?: string,
    required?: boolean,
    className?: string,
    side?: PopoverContentProps['side'],
    disabled?: boolean,
    search?: boolean,
    disableClearIcon?: boolean
}

const slugifyConfig = {
    replacement: '_',
    lower: true
    // strict: true
};

export default function Combobox({
    value,
    onChange,
    items,
    placeholder = 'placeholder.choose',
    className,
    side = 'bottom',
    disabled = false,
    search = true,
    disableClearIcon = false
}: ComboboxProps) {
    // hook
    const { t } = useTranslation();
    const [open, setOpen] = useState<boolean>(false);
    const selectValue = items?.find(item => item.value === String(value));

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger disabled={disabled} asChild>
                <Button
                    variant='input'
                    size='input'
                    role='combobox'
                    aria-expanded={open}
                    className={cn(
                        'w-full relative flex justify-start pr-10',
                        !selectValue && 'text-placeholder',
                        className && className
                    )}
                >
                    <div className='truncate'>
                        {value ? selectValue?.label : `${t(placeholder)}`}
                    </div>
                    {(selectValue || disableClearIcon) && (
                        <ChevronDown className={cn(
                            'h-4 w-4 text-icon-1 icon-right-input',
                            disabled && 'hover:text-icon-1 hover:cursor-not-allowed'
                        )}
                        />
                    )}
                    {/* {selectValue && !disableClearIcon && (
                        <X
                            className='h-4 w-4 text-icon-1 icon-right-input'
                            onPointerDown={() => {
                                !disabled && onChange && onChange(undefined);
                            }}
                        />
                    )} */}
                </Button>
            </PopoverTrigger>
            <PopoverContent widthFull className='p-0' side={side}>
                <Command>
                    <CommandList>
                        <CommandEmpty>{t('sentences.no_data')}</CommandEmpty>
                        <CommandGroup>
                            {items?.map(item => (
                                <CommandItem
                                    key={item.value}
                                    // value={item.value}
                                    value={item.label}
                                    onSelect={() => {
                                        onChange(item);
                                        setOpen(false);
                                    }}
                                >
                                    {/* <Tooltip
                                        content={item.label}
                                        triggerClassName='w-full flex items-center'
                                        side='right'
                                    > */}
                                    <CheckIcon
                                        className={cn(
                                            'mr-2 h-4 w-4',
                                            String(value) === item.value ? 'opacity-100' : 'opacity-0'
                                        )}
                                    />
                                    <div className='truncate'>{item.label}</div>
                                    {/* </Tooltip> */}
                                </CommandItem>
                            ))}
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    );
}
